$(document).ready(() => {

    // let resizeId;
    let wWidth = $(window).width()
    let navState = false
    const $header = $('.page-header__mobile-nav')
    const $nav = $header.find('.nav')
    const $parentLi = $nav.find('.menu-item-has-children')
    const $parentLinks = $parentLi.children('a')
    const $subMenu = $parentLi.children('.sub-menu')
    let isObserver = true
    let observer
    // let controller = new ScrollMagic.Controller();
    let isTouch

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=')

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1])
            }
        }
    }

    if (
        !('IntersectionObserver' in window) ||
        !('IntersectionObserverEntry' in window) ||
        !('isIntersecting' in window.IntersectionObserverEntry.prototype)
    ) {
        isObserver = false
        $('html').removeClass('is-observer')
    }

    if (isObserver) {
        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible')
                        observer.unobserve(entry.target)
                    }
                })
            }, {
            rootMargin: '0px 0px -15% 0px'
        }
        )
    }

    function isTouchDevice() {
        const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
        const mq = (query) => {
            return window.matchMedia(query).matches
        }

        if (
            'ontouchstart' in window ||
            // eslint-disable-next-line no-undef
            (window.DocumentTouch && document instanceof DocumentTouch)
        ) {
            return true
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(
            ''
        )
        return mq(query)
    }

    if (isTouchDevice()) {
        isTouch = true
        $('html').addClass('is-touch')
    }

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    function debounce(func, wait, immediate, ...args) {
        let timeout
        return function () {
            const context = this
            const later = function () {
                timeout = null
                if (!immediate) func.apply(context, args)
            }
            const callNow = immediate && !timeout
            clearTimeout(timeout)
            timeout = setTimeout(later, wait)
            if (callNow) func.apply(context, args)
        }
    }


    function disableScrolling() {
        if ($(document).height() > $(window).height()) {
            const scrollTop = $('html').scrollTop() ?
                $('html').scrollTop() :
                $('body').scrollTop() // Works for Chrome, Firefox, IE...
            $('html').addClass('disable-scrolling').css('top', -scrollTop)
        }
    }

    function enableScrolling() {
        const scrollTop = parseInt($('html').css('top'), 10)
        $('html').removeClass('disable-scrolling')
        $('html,body').scrollTop(-scrollTop)
    }

    function updateNav() {
        $header.removeClass('is-opened')
        $parentLi.removeClass('is-active')
        $parentLinks.attr('aria-expanded', 'false')

        if (wWidth < 1280) {
            $subMenu.slideUp()
        } else {
            $subMenu.show()
        }
    }

    function handleNavTouch(e) {
        const $item = $(e.target)
        const $submenu = $item.siblings('.sub-menu')

        if ($item.parent().hasClass('is-active')) {
            $item.attr('aria-expanded', 'false').parent().removeClass('is-active')

            if (wWidth < 1280) {
                $submenu.slideUp()
            }
        } else {
            $parentLi.removeClass('is-active')
            $item.attr('aria-expanded', 'true').parent().addClass('is-active')

            if (wWidth < 1280) {
                $subMenu.slideUp()
                $submenu.slideDown()
            }
        }
    }

    function bindEvents() {
        const $overlay = $('.page-header__mobile-overlay')
        const $wrap = $('.page-header__mobile-wrap')

        //v-r-mobile nav
        const mobileAni = new TimelineLite({
            paused: true
        })

        mobileAni.to($wrap, 0.5, {
            x: 0
        })

        $('.v-r-mobile-nav__items').each(function () {
            var menuItem = $(this).find('li')
            mobileAni.staggerTo(menuItem, 0.2, {
                duration: 0.2,
                x: 0,
                opacity: 1
            }, 0.1)
        })




        $('.hamburger').on('click', () => {
            if (navState) {
                $header.removeClass('is-opened')
                enableScrolling()
                mobileAni.reverse()


            } else {
                $header.addClass('is-opened')
                disableScrolling()
                $wrap.show()
                mobileAni.play()


            }

            navState = !navState
        })

        $parentLinks.on('touchend', (e) => {
            e.preventDefault()
            handleNavTouch(e)
        })

        /* Navigation with tabbing */
        $(window).keyup((e) => {
            const code = e.keyCode ? e.keyCode : e.which

            if (code === 9) {
                if ($parentLinks.filter(':focus').length) {
                    handleNavTouch(e)
                } else if ($nav.find('>li>a:focus').length) {
                    $parentLi.removeClass('is-active')

                    if (wWidth < 1280) {
                        $parentLi.children('.sub-menu').slideUp()
                    }
                }
            }
        })
    }

    function initSM() {
        if (controller === null || controller === undefined) {
            // reinitialize ScrollMagic only if it is not already initialized
            controller = new ScrollMagic.Controller()
        }
    }

    const doneResizing = debounce(() => {
        const width = $(window).width()



        if (wWidth !== width) {
            wWidth = width

            // if (controller !== null && controller !== undefined) {
            //   // completely destroy the controller
            //   controller = controller.destroy(true);
            //   initSM()
            // }
        }
    }, 500)



    function initModePageCarousel() {
        const $carousel = $('.mode-page-carousel__inner')

        if (!$carousel.length) return

        $($carousel).slick({
            dots: false,
            prevArrow: $('.prev-car'),
            nextArrow: $('.next-car'),
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3500,
            fade: true,
            pauseOnHover: false,
        })
    }

    function initHomePareHero() {
        const $bg = $('.home-page-hero__background')
        const $heading = $('.home-page-hero__heading')
        const $phone = $('.home-page-hero__phone-img')
        const $fItems = $('.home-page-hero__features-item')
        const $carousel = $('.home-find-out-more__carousel')

        if (!$phone.length) return

        let bgWidth = ["-10%", "120%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-20%", "140%"]
        }

        $($carousel).slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            arrows: true,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
        })



        const tween = new TimelineLite()

        tween.add(
            TweenLite.to($phone, 1, {
                y: -700
            })
        )

        const controller = new ScrollMagic.Controller()

        const scene = new ScrollMagic.Scene({
            triggetElement: '.home-page-hero__phone-img',
            duration: 3000,
            triggerHook: 0.3
        })
            .setTween(tween)
            .addTo(controller)




        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: 0,
        })

        tl.to($heading, {
            duration: 0.4,
            ease: 'linear',
            opacity: 1,
            stagger: 0.2,
        })

        tl.to($fItems, {
            duration: 0.4,
            ease: 'linear',
            opacity: 1,
            stagger: 0.2,
        })
    }

    function initHomeOrderNow() {
        const controller = new ScrollMagic.Controller()
        const tween = new TimelineLite()
        const $bg = $('.home-order-now__background')
        const $phone = $('.home-order-now__phone-image')
        const $phoneContainer = $('.home-order-now__phone-container')
        const $logos = $('.home-order-now__carrier-featured-img')

        let t2 = gsap.timeline({
            scrollTrigger: {
                trigger: $logos,
                start: 'top 75%'
            }
        })

        t2.to($logos, {
            duration: 0.35,
            scale: 1,
            opacity: 1,
            stagger: 0.2
        })

        if (!$phone.length) return

        let bgWidth = ["-35%", "170%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-30%", "160%"]
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".home-order-now__background",
                start: '-500 800'
            }
        })

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: 0,
        })
        tl.to($phoneContainer, {
            duration: 0.45,
            opacity: 1
        })


        tween.add(
            TweenLite.to($phone, 1, {
                y: 0
            })
        )

        const scene = new ScrollMagic.Scene({
            triggerElement: '.home-order-now__phone-image',
            duration: 900,
            triggerHook: '0.75'
        })
            .setTween(tween)
            .addTo(controller)
    }

    function initLaunchPhone() {
        const $bg = $('.launch-phone__background')
        const $phone = $('.launch-phone__phone-image')

        if (!$phone.length) return

        let bgWidth = ["-35%", "170%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-30%", "160%"]
        }

        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: 0,
        })
    }

    function initCirvedBackground() {
        const $bg = $('.curved-background')

        if (!$bg.length) return

        let bgWidth = ["-10%", "120%"]

        if ($(window).width() < 960) {
            bgWidth = ["-40%", "180%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-50%", "160%"]
        }

        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: 0,
        })
    }

    initCirvedBackground()

    function initSubscriptionLaunchPhone() {
        const $bg = $('.subscription-launch-phone__background')
        const $phone = $('.subscription-launch-phone__phone-image')

        if (!$phone.length) return

        let bgWidth = ["-35%", "170%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-30%", "160%"]
        }

        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: 0,
        })
    }

    function initLaunchDeviceCompare() {
        const $bg = $('.launch-device-compare__background')

        if (!$bg.length) return

        let bgWidth = ["-35%", "170%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-30%", "160%"]
        }

        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: 0,
        })
    }

    function initAboutHeader() {
        const $bg = $('.about-page-header__background')
        const $header = $('.about-page-header__inner h1')
        const $grad = $('.about-page-header__background-gradient')
        const $phone = ('.about-get-into-mode__phone-img')

        if (!$phone.length) return


        let bgWidth = ["-10%", "120%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-20%", "140%"]
        }

        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: "-55px",
        })
        tl.to($header, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
        })
        tl.to($grad, {
            duration: 0.2,
            opacity: 1
        }, "-=0.85")
        tl.to($phone, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
        }, "-=0.55")
    }

    function initLaunchHeader() {
        const $bg = $('.launch-hero__background')
        const $header = $('.launch-hero__heading')
        const $grad = $('.launch-hero__background-gradient')
        const $phone = ('.launch-hero__phone-img')

        if (!$phone.length) return


        let bgWidth = ["-10%", "120%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-20%", "140%"]
        }

        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: "-55px",
        })
        tl.to($header, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
        })
        tl.to($grad, {
            duration: 0.2,
            opacity: 1
        }, "-=0.85")
        tl.to($phone, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
        }, "-=0.55")
    }

    function initAboutGetInjtoMode() {
        const $phone = ('.about-get-into-mode__phone-img')
        const controller = new ScrollMagic.Controller()
        const tween = new TimelineLite()

        if (!$phone.length) return

        tween.add(
            TweenLite.to($phone, 1, {
                y: 150
            })
        )

        const scene = new ScrollMagic.Scene({
            triggerElement: $phone,
            duration: 900,
            triggerHook: '0.2'
        })
            .setTween(tween)
            .addTo(controller)
    }

    function initAboutFeatured() {
        const $sticker = $('.about-main__item-image-container')
        const $logos = $('.about-featured__item')

        if (!$logos.length) return

        $sticker.each(function (i, e) {
            console.log(this)
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: 'top 75% '
                }
            })

            tl.to(this, {
                duration: 0.35,
                scale: 1.1,
                opacity: 1
            })
            tl.to(this, {
                duration: 0.2,
                scale: 1,
                opacity: 1
            })
        })
        let t2 = gsap.timeline({
            scrollTrigger: {
                trigger: $logos,
                start: 'top 75%'
            }
        })

        t2.to($logos, {
            duration: 0.35,
            scale: 1,
            opacity: 1,
            stagger: 0.2
        })


    }

    function initProductAccordian() {
        const $item = $('.product-page-accordian__item-title')

        if (!$item.length) return

        $item.on('click', function () {
            $(this).toggleClass('active')
            $(this).siblings(".product-page-accordian__item-hidden").toggleClass('active')
        })
    }

    function initFaqAccordian() {
        const $item = $('.about-subscription-faq__item .title')

        if (!$item.length) return

        $item.on('click', function () {
            $(this).toggleClass('active')
            $(this).siblings(".desc").toggleClass('active')
        })
    }

    initFaqAccordian()

    function initModePageHeader() {
        const $bg = $('.mode-page__background')
        const $phone = $('.mode-page__inner img')
        const $button = $('.mode-page__button')
        const $grad = $('.mode-page__background-gradient')

        let bgWidth = ["-10%", "120%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-20%", "140%"]
        }

        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: "0px",
        })
        tl.to($header, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
        })
        tl.to($grad, {
            duration: 0.2,
            opacity: 1
        })
        tl.to($phone, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
        }, "-=0.55")
        tl.to($button, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
        }, "-=0.55")

        const tween = new TimelineLite()

        tween.add(
            TweenLite.to($phone, 1, {
                y: -700
            })
        )

        const controller = new ScrollMagic.Controller()

        const scene = new ScrollMagic.Scene({
            triggetElement: $phone,
            duration: 3000,
            triggerHook: 0.3
        })
            .setTween(tween)
            .addTo(controller)


    }

    function initModeDeviceFeatures() {
        const $bg = $('.device-features__background')
        // const $phone = $('.mode-page__inner img')
        // const $button = $('.mode-page__button')

        let bgWidth = ["-20%", "140%"]

        if ($(window).width() < 960) {
            bgWidth = ["-120%", "340%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-25%", "150%"]
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: $bg,
                start: '-500 800'
            }
        })

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: "0px",
        })
    }

    function inintEarnFeatures() {
        const $container = $('.earn-page-accordian__inner')
        const $seeMore = $('.earn-page-accordian__button-see-more')
        const $leftFade = $('.earn-page-accordian__left-item')
        const $rightFade = $('.earn-page-accordian__right-item')
        const $orderBtn = $('.earn-page-accordian__button-order')

        $seeMore.on('click', function () {
            $container.addClass('active')
            $leftFade.addClass('active')
            $rightFade.addClass('active')
            $orderBtn.addClass('active')
            $seeMore.hide()
        })
    }

    function seemore() {
        $('.see-more-show').on('click', function (e) {
            e.preventDefault()

            let target = $(this).data('target')
            $(target).addClass('active')
        })

        $('.see-more-hide').on('click', function (e) {
            e.preventDefault()

            let target = $(this).data('target')
            $(target).removeClass('active')
        })
    }
    seemore()

    function initPageTemplate() {
        const $bg = $('.page-template__background')
        const $header = $('.page-template__inner-h')
        const $grad = $('.page-template__background-gradient')
        // const $phone = ('.about-get-into-mode__phone-img');

        if (!$bg.length) return


        let bgWidth = ["-10%", "120%"]

        if ($(window).width() < 960) {
            bgWidth = ["-100%", "300%"]
        } else if ($(window).width() < 1500) {
            bgWidth = ["-20%", "140%"]
        }

        const tl = gsap.timeline()

        tl.to($bg, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
            width: bgWidth[1],
            left: bgWidth[0],
            top: "0px",
        })
        tl.to($header, {
            duration: 0.75,
            ease: "power1.out",
            opacity: 1,
        })
        tl.to($grad, {
            duration: 0.2,
            opacity: 1
        }, "-=0.85")
        // tl.to($phone, { duration: 0.75, ease: "power1.out", opacity: 1, }, "-=0.55");

    }

    function initPartnersIcons() {
        const $logos = $('.earn-page-partners__icon-item')

        let t2 = gsap.timeline({
            scrollTrigger: {
                trigger: $logos,
                start: 'top 75%'
            }
        })

        t2.to($logos, {
            duration: 0.35,
            scale: 1,
            opacity: 1,
            stagger: 0.2
        })
    }

    const unlockedPhone = 32165318295619
    const lockedPhone = 32165318295619
    const unlockGSM = 32123879161923
    const phoneCase = null

    function clearCart() {
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            async: false
        })
    }

    function addUnlockedProtuctsToCart(addPhoneCase, checkout = false) {
        clearCart()

        if (addPhoneCase) {
            //this is the free phone
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                    "id": phoneCase,
                    quantity: 1
                },
                async: false
            })
        }

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                "id": unlockGSM,
                quantity: 1
            },
            async: false
        })

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                "id": unlockedPhone,
                quantity: 1
            },
            async: false
        })

        if(checkout) {
            window.location = '/checkout'
        } else {
            window.location = '/cart'
        }
    }

    $('#wholesale-buy').click(function (e) {
        e.preventDefault()

        clearCart()

        let quantity = $('#wholesale-quantity').val()

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                "id": unlockedPhone,
                quantity: quantity
            },
            async: false
        })

        window.location = '/checkout'
    })

    $("#add-products").click(function () {

        addUnlockedProtuctsToCart(false)
    })

    $(".add-products").click(function (e) {
        e.preventDefault()

        addUnlockedProtuctsToCart(false)
    })

    if (getUrlParameter('add-phone')) {
        addUnlockedProtuctsToCart(false)
    }

    if (getUrlParameter('add-phone-direct')) {
        addUnlockedProtuctsToCart(false, true)
    }

    if (getUrlParameter('renew-subscription')) {
        clearCart()

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id: 39271217102915,
                quantity: 1
            },
            async: false
        })

        window.location = '/checkout'
    }

    if (getUrlParameter('gift')) {
        clearCart()

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id: 39326462967875,
                quantity: 1
            },
            async: false
        })

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id: 39326476402755,
                quantity: 1
            },
            async: false
        })

        window.location = '/checkout'
    }

    const gsmUnlock = 32123879161923
    const MP1Data = {
        'default' : {
            'variant_id': 32165318295619,
            'price': 119.99,
            'discount': '50%',
        },
        '6834589543507': {
            'variant_id': 39477883306051,
            'price': 79.99,
            'discount': '79%',
        },
        '6878786554408': {
            'variant_id': 39477883371587,
            'price': 89.99,
            'discount': '75%',
        },
        '6778990909009': {
            'variant_id': 39477883437123,
            'price': 99.99,
            'discount': '70%',
        },
        '6483675876510': {
            'variant_id': 39477883502659,
            'price': 109.99,
            'discount': '66%',
        }
    }

    const productParameter = getUrlParameter('mpid')
    var currentProductId = 'default'

    if(productParameter && MP1Data[productParameter]) {
        currentProductId = productParameter
    }

    var currentProduct = MP1Data[currentProductId]
    
    $('.mp1-price').html(currentProduct.price)
    $('.mp1-discount').html(currentProduct.discount)

    $(".add-mp1").click(function (e) {
        e.preventDefault()

        addMP1()
    })

    $(`.hide-mp1-${currentProductId}`).hide()
    $(`.show-mp1-${currentProductId}`).show()

    function addMP1() {
        clearCart()
        
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                "id": gsmUnlock,
                quantity: 1
            },
            async: false
        })

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                "id": currentProduct.variant_id,
                quantity: 1
            },
            async: false
        })

        window.location = '/cart'
    }

    function addLockedProtuctsToCart(addPhoneCase) {
        clearCart()

        if (addPhoneCase) {
            //this is the free phone
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                    "id": phoneCase,
                    quantity: 1
                },
                async: false
            })
        }

        //this is the free phone
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                "id": lockedPhone,
                quantity: 1
            },
            async: false
        })

        window.location = '/cart'
    }

    $(".remove-from-cart").click(function (e) {
        e.preventDefault()

        var id = $(this).data('id')

        if (id == unlockGSM) {
            addLockedProtuctsToCart(false)
        } else if (id == unlockedPhone || id == lockedPhone) {
            clearCart()
            window.location = '/cart'
        } else {
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                    "id": id,
                    quantity: 0
                },
                async: false
            })

            window.location = '/cart'
        }
    })

    function initUpdateCart() {
        const $input = $('.mode-update-qty')
        let hasGSMUnlock = false

        $input.change(function () {
            const cartQt = $(this).val()
            console.log(cartQt)

            $.getJSON('/cart.js', function(cart) {
                let items = cart.items

                $(items).each(function() {
                    if(this.id == unlockGSM) {
                        hasGSMUnlock = true
                    }
                })
    
                if(hasGSMUnlock) {
                    $(items).each(function() {
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            dataType: 'json',
                            data: {
                                "id": this.id,
                                quantity: cartQt
                            },
                            async: false
                        })
                    })

                     setTimeout(function () {
                        window.location.reload()
                    }, 100)
                }
            })
        })
    }




    /* FUNCTION CALLS */
    /* ============= */
    bindEvents()
    initHomePareHero()
    initHomeOrderNow()
    initAboutHeader()
    initAboutGetInjtoMode()
    initAboutFeatured()
    initLaunchHeader()
    initLaunchPhone()
    initLaunchDeviceCompare()

    initSubscriptionLaunchPhone()

    initProductAccordian()
    initModePageCarousel()
    initModePageHeader()
    initModeDeviceFeatures()
    inintEarnFeatures()
    initPageTemplate()
    initPartnersIcons()
    initUpdateCart()

    if (isObserver) {
        $('.js-visibility').each((i, el) => {
            observer.observe(el)
        })
    }

    $(window).on('scroll', () => {

        let scroll = $(window).scrollTop()
        let $header = $(".page-header")

        if (scroll >= 50) {
            $header.addClass('active')
        }

        if (scroll <= 50) {
            $header.removeClass('active')
        }
    })

    $(window).on('load', () => { })

    $(window).on('resize', doneResizing)

    tippy('#upgrade-help', {
        content: 'With this option, our Mode phone will work with any GSM carrier in the world.',
    })

    tippy('#storage-help', {
        content: '32GB Internal Storage + 32GB External Storage Included',
    })

    $('.reviews__items').slick({
        dots: false,
        prevArrow: $('.prev-car'),
        nextArrow: $('.next-car'),
        infinite: false,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        pauseOnHover: false,
    })

    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault()

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500)
    })

    $(document).on('click', '.blog-show a', function (event) {
        event.preventDefault()
        let href = $(this).attr('href')
        if(!href.includes('MODE_CUSTOMER_EMAIL')) {
            window.open(
                href,
                '_blank'
            )
            return
        }

        let savedEmail = localStorage.getItem("mode_customer_email")
        let savedPhone = localStorage.getItem("mode_customer_phone")
        
        if(savedEmail) {
            let newUrl = href.replace('MODE_CUSTOMER_EMAIL', savedEmail)

            sendDeal(savedEmail, savedPhone, newUrl)

            window.open(
                newUrl,
                '_blank'
            )

            return
        }

        $('#deal-pop-up-form-url').val(href)

        $('#deal-pop-up').show()
    })
    
    $(document).on('click', '#deal-pop-up-close', function (event) {
        event.preventDefault()
        $('#deal-pop-up').hide()
    })

    $("#deal-pop-up-form").submit(function(event) {
        event.preventDefault()

        let url = $('#deal-pop-up-form-url').val()
        let email = $('#deal-pop-up-form-email').val()
        let phone = $('#deal-pop-up-form-phone').val()

        if(!url || !email) {
            return
        }

        let newUrl = url.replace('MODE_CUSTOMER_EMAIL', email)
        
        localStorage.setItem('mode_customer_email', email)
        localStorage.setItem('mode_customer_phone', phone)

        sendDeal(email, phone, newUrl)

        window.open(
            newUrl,
            '_blank'
        )

        $('#deal-pop-up').hide()
    })
    
    processGHCookie()

    addTuneCookie()

    addTrackingCookies()

    if($('#mode-freebies')) {
         $(document).on('click', '.giraffly_hoverButton', function (event) {
            event.preventDefault()

            $("#mode-freebies").appendTo(".giraffly_Off-Canvas-Content").show()
        })
    }

    $(document).on('click', '.product-template-simple .btn-add', function (event) {
        setTimeout(() => {
            window.location = '/checkout'
        }, 1000);

    })

    if (getUrlParameter('product-view')) {
        let proudct = getUrlParameter('product-view')

        setTimeout(function(){
            $(`[data-handle="${proudct}"]`).trigger('click')
        }, 1500)
    }
})

function sendDeal(email, phone, url) {
    $.ajax({
        type: 'POST',
        url: 'https://subscription.modephone.com/api/web-deals',
        dataType: 'json',
        data: {
            email: email,
            phone: phone,
            url: url,
        },
        async: false
    })
}

function processGHCookie() {
    let GH = getCookie('_growthhero_payload')

    if (!GH) {
        return
    }

    GH = JSON.parse(GH)

    if (!GH) {
        return
    }

    let partnerId = GH.partner_id

    let refId = getCookie('_affiliate_id')

    if (partnerId == refId) {
        return
    }

    let maxAge = 2.592e+6

    document.cookie = `_affiliate_id=${partnerId};path=/;domain=modephone.com;max-age=${maxAge}`

}

function addTuneCookie() {
    const tuneTransactionId = getUrlParameter('transaction_id')

    if(!tuneTransactionId) {
        return
    }

    let maxAge = 1.21e+6

    document.cookie = `_tune_transaction_id=${tuneTransactionId};path=/;domain=modephone.com;max-age=${maxAge}`
}

function addTrackingCookies() {
    let maxAge = 1.21e+6

    const gclid = getUrlParameter('gclid')

    if(gclid) {
        document.cookie = `_gclid=${gclid};path=/;domain=modephone.com;max-age=${maxAge}`
    }

    setGACIDCookie()
}

// ga client id
function setGACIDCookie(attempts = 0)
{
    if(attempts > 10) {
        return
    }

    if (window.ga && ga.loaded) {
        
        var clientId = null

        ga(function(tracker) {
            clientId = tracker.get('clientId')
        })

        if(!clientId) {
             setTimeout(function(){
                setGACIDCookie(attempts + 1)
            }, 2000)

            return;
        }

        const gacid = getCookie('_gacid')
        let maxAge = 1.21e+6

        if(gacid != clientId) {
            document.cookie = `_gacid=${clientId};path=/;domain=modephone.com;max-age=${maxAge}`
        }
    } else {
        setTimeout(function(){
            setGACIDCookie(attempts + 1)
        }, 2000)
    }
}

function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=')

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1])
        }
    }
}